import {Observable, Subscription} from 'rxjs';
import {ResizeObserver, ResizeObserverEntry} from '@juggle/resize-observer';
import {Directive, ElementRef, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {RtPlatformService} from '../rt-platform/rt-platform.service';


@Directive({ selector: '[rtElementResized]' })
export class RtElementResizedDirective implements OnInit, OnDestroy {
  @Output() rtElementResized = new EventEmitter<ResizeObserverEntry[]>();

  /** Component subscriptions. Will be unsubscribed on destroy. */
  private readonly subscription = new Subscription();

  constructor(private host: ElementRef, private platform: RtPlatformService) {}

  ngOnInit(): void {
    // Subscribe to resize event on the host element and emit resize entry on each trigger.
    this.subscription.add(
      this.observeResize(this.host.nativeElement).subscribe(resizeEntry => this.rtElementResized.emit(resizeEntry))
    );
  }

  /**
   * Observe resize event on the provided element.
   */
  public observeResize(element: Element): Observable<ResizeObserverEntry[]> {
    if (!this.platform.isBrowser) {
      return new Observable();
    }
    return new Observable(subscriber => {
      const resizeObserver = new ResizeObserver(entries => {
        subscriber.next(entries);
      });

      resizeObserver.observe(element);
      return () => {
        resizeObserver.unobserve(element);
      };
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
